import { useParams } from 'react-router-dom';
import { contactService } from '../../../services/contactService';
import type { ImportField } from '../../../types/import';
import { ExcelImportPage } from '../../common/import';

const CONTACT_IMPORT_FIELDS: ImportField[] = [
  { key: 'lastName', label: 'Прізвище', required: true },
  { key: 'firstName', label: 'Ім\'я', required: true },
  { key: 'middleName', label: 'По батькові' },
  { key: 'phoneNumber', label: 'Телефон' },
  { key: 'email', label: 'Email' },
  { key: 'type', label: 'Тип (клієнт / постачальник / обидва)' },
];

export default function ContactImportPage() {
  const { id } = useParams<{ id: string }>();
  const companyId = id ? parseInt(id) : null;

  return (
    <ExcelImportPage
      title="Імпорт контактів"
      description="Оберіть файл .xlsx, перший рядок якого містить заголовки, і вкажіть, яка колонка до якого поля належить. Якщо тип не вказано, контакт стає клієнтом. Контакти, що вже існують з тими ж іменем, телефоном і email, пропускаються."
      companyId={companyId}
      backPath={`/companies/${companyId}/contacts`}
      backLabel="Назад"
      fields={CONTACT_IMPORT_FIELDS}
      loadPreview={contactService.previewImport}
      runImport={contactService.importFromExcel}
    />
  );
}
